/* eslint-disable */ import { assertBoolean, assertNumber, attributeSwitchComponent, detailComponent, distanceDimensionComponent, entityHeaderComponent, genericDimensionComponent, memoEval, sceneEntityPropertiesComponent, sceneEntitySelectHotspotComponent, sketchingRectangleComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const stairsComponents = [
    attachComponent.withComponent(detailComponent, 'main', true).withEntity('Stairs').attach(memoEval(()=>[], ()=>({
            title: 'Steps',
            subtitle: '',
            description: 'Stair surface'
        }))),
    attachComponent.withComponent(sketchingRectangleComponent, 'main', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.width,
            self.$depth,
            self.angle
        ], (x, y, width, $depth, angle)=>({
            x: x,
            y: y,
            width: width,
            depth: $depth,
            angle: angle,
            key: 'main'
        })), (state)=>{
        assertNumber(state.x);
        assertNumber(state.y);
        assertNumber(state.width);
        assertNumber(state.angle);
        return {
            x: state.x,
            y: state.y,
            width: state.width,
            angle: state.angle
        };
    }),
    attachComponent.withComponent(sketchingRectangleComponent, 'read', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.width,
            self.$depth,
            self.angle
        ], (x, y, width, $depth, angle)=>({
            x: x,
            y: y,
            width: width,
            depth: $depth,
            angle: angle,
            key: 'viewmode'
        })), (state)=>{
        assertNumber(state.x);
        assertNumber(state.y);
        assertNumber(state.width);
        assertNumber(state.angle);
        return {
            x: state.x,
            y: state.y,
            width: state.width,
            angle: state.angle
        };
    }),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'main', true).withEntity('Stairs').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ],
        toolStates: [
            'Selection'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$centerX,
            self.$centerZ
        ], ($centerX, $centerZ)=>({
            offsetX: $centerX,
            offsetY: 100,
            offsetZ: $centerZ
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'main', true).withEntity('Stairs').attach(memoEval(()=>[], ()=>({}))),
    attachComponent.withComponent(attributeSwitchComponent, 'balustradeLeft', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.balustradeLeft
        ], (balustradeLeft)=>({
            value: balustradeLeft
        })), (state)=>{
        assertBoolean(state.value);
        return {
            balustradeLeft: state.value
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'balustradeRight', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.balustradeRight
        ], (balustradeRight)=>({
            value: balustradeRight
        })), (state)=>{
        assertBoolean(state.value);
        return {
            balustradeRight: state.value
        };
    }),
    attachComponent.withComponent(genericDimensionComponent, 'numberOfSteps', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.numberOfSteps
        ], (numberOfSteps)=>({
            value: numberOfSteps,
            min: 1,
            max: 30,
            unit: 'steps'
        })), (state)=>{
        assertNumber(state.value);
        return {
            numberOfSteps: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'riser', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.riserDistance
        ], (riserDistance)=>({
            value: riserDistance,
            min: 100,
            max: 400
        })), (state)=>{
        assertNumber(state.value);
        return {
            riserDistance: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'goingDistance', true).withEntity('Stairs').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.goingDistance
        ], (goingDistance)=>({
            value: goingDistance,
            min: 10,
            max: 400
        })), (state)=>{
        assertNumber(state.value);
        return {
            goingDistance: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'sketching', true).withEntity('Stairs').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.angle
        ], (x, y, angle)=>({
            offsetX: x,
            offsetZ: y,
            offsetY: 0,
            rotationY: angle
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'main', true).withEntity('Stairs').withGradualFilter({
        viewStates: [
            '3dView'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.$levelHeight,
            self.y,
            self.angle
        ], (x, $levelHeight, y, angle)=>({
            offsetX: x,
            offsetY: $levelHeight,
            offsetZ: y,
            rotationY: angle
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'mainFloorPlan', true).withEntity('Stairs').withGradualFilter({
        navigationStates: [
            'Properties',
            'Summary'
        ],
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.$levelHeight,
            self.angle
        ], (x, y, $levelHeight, angle)=>({
            offsetX: x,
            offsetZ: y,
            offsetY: $levelHeight,
            rotationY: angle
        })))
];

//# sourceMappingURL=stairs.js.map